/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { PropsWithChildren } from "react";
import Layout from "../utilities/Layout";

type ContentProps = PropsWithChildren<{}>;

export default function Content(props: ContentProps) {
  const containerCss = css`
    padding-left: ${Layout.S}px;
    padding-right: ${Layout.S}px;
  `;
  return <div css={containerCss}>{props.children}</div>;
}
